import React, { useState, useEffect } from 'react';
import { Button, Space, message, Breadcrumb, Typography, Card } from 'antd';
import { ArrowLeftOutlined, SaveOutlined, DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import VisualRuleBuilder from '../VisualRuleBuilder';
import s from './s.module.less';

const { Title } = Typography;

const VisualFlowBuilderPage: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    
    const assessmentUuid = searchParams.get('uuid') || '';

    const handleBack = () => {
        navigate(-1);
    };

    const handleSave = () => {
        setLoading(true);
        // 这里可以添加保存逻辑
        setTimeout(() => {
            setLoading(false);
            message.success('Flow saved successfully');
        }, 1000);
    };

    const handleExport = () => {
        message.info('Export functionality will be implemented');
    };

    const handleImport = () => {
        message.info('Import functionality will be implemented');
    };

    const breadcrumbItems = [
        {
            title: 'Operation',
        },
        {
            title: 'Text Visit Workflows',
        },
        {
            title: 'Decision Tree',
        },
        {
            title: 'Visual Flow Builder',
        },
    ];

    return (
        <div className={s.visualFlowBuilderPage}>
            <div className={s.pageHeader}>
                <div className={s.headerContent}>
                    <div className={s.headerLeft}>
                        <Breadcrumb items={breadcrumbItems} />
                        <div className={s.titleSection}>
                            <Title level={2} style={{ margin: 0 }}>
                                Visual Flow Builder
                            </Title>
                            <p className={s.subtitle}>
                                Create decision tree rules with visual flow
                            </p>
                        </div>
                    </div>
                    <div className={s.headerRight}>
                        <Space>
                            <Button
                                icon={<ArrowLeftOutlined />}
                                onClick={handleBack}
                            >
                                Back
                            </Button>
                            <Button
                                icon={<UploadOutlined />}
                                onClick={handleImport}
                            >
                                Import
                            </Button>
                            <Button
                                icon={<DownloadOutlined />}
                                onClick={handleExport}
                            >
                                Export
                            </Button>
                            <Button
                                type="primary"
                                icon={<SaveOutlined />}
                                loading={loading}
                                onClick={handleSave}
                            >
                                Save
                            </Button>
                        </Space>
                    </div>
                </div>
            </div>
            
            <div className={s.content}>
                <VisualRuleBuilder 
                    className={s.visualRuleBuilder}
                    assessmentUuid={assessmentUuid}
                    fullscreen={true}
                />
            </div>
        </div>
    );
};

export default VisualFlowBuilderPage;
